export enum ProjectIcon {}
